import { apiClient } from '@/lib/apiClient';
import type { QueryOptions } from '@/lib/reactQuery';
import type { Id } from '@/types/api';
import type { CenterSchedulingSettings, SchedulingEnrollment } from '@/types/scheduling';
import { useQuery } from '@tanstack/react-query';

export interface StudentSchedulingDetails {
  id: Id;
  inCenterCenterSettings?: CenterSchedulingSettings;
  onlineCenterSettings?: CenterSchedulingSettings;
  enrollments: SchedulingEnrollment[];
}

export interface GetStudentsSchedulingDetailsResponseData {
  students: StudentSchedulingDetails[];
}

export const getStudentsSchedulingDetails = async () => {
  const response = await apiClient.get<GetStudentsSchedulingDetailsResponseData>('/v1/scheduling/get-students-scheduling-details');
  return response.data;
};

interface UseGetStudentsSchedulingDetailsOptions {
  options?: QueryOptions<GetStudentsSchedulingDetailsResponseData>;
}

export const GET_STUDENTS_SCHEDULING_DETAILS_QUERY_KEY = 'getStudentsSchedulingDetails';

export const useGetStudentsSchedulingDetails = ({ options }: UseGetStudentsSchedulingDetailsOptions) => {
  return useQuery({
    queryKey: [GET_STUDENTS_SCHEDULING_DETAILS_QUERY_KEY],
    queryFn: () => getStudentsSchedulingDetails(),
    ...options,
  });
};
